"use client";
import { StaticAccordion } from "@/common/lib/types";
import { HTMLAttributes, useEffect, useState } from "react";
import PortableText from "../PortableText";
import Accordion from "../ui/accordion";
import clsx from "clsx";

interface IProps extends Omit<HTMLAttributes<HTMLDivElement>, "content"> {
  content: StaticAccordion;
  classNames?: {
    accordion?: {
      title?: string;
      container?: string;
    };
  };
}
const Faq = ({ content, className, classNames, ...props }: IProps) => {
  const [isExpandAll, setIsExpandAll] = useState(false);
  const [controlledOpenIndices, setControlledOpenIndices] = useState<number[] | undefined>(
    undefined,
  );

  const handleToggleAll = () => {
    setIsExpandAll((prev) => {
      const next = !prev;
      const indices = next ? (content?.items?.map((_, idx) => idx) ?? []) : [];
      setControlledOpenIndices(indices);
      return next;
    });
  };

  useEffect(() => {
    if (controlledOpenIndices !== undefined) {
      const timer = setTimeout(() => setControlledOpenIndices(undefined), 0);
      return () => clearTimeout(timer);
    }
  }, [controlledOpenIndices]);

  return (
    <div className={clsx("px-4 md:px-12", className)} {...props}>
      {content?.title ? (
        <div className="mb-8">
          <h5 className="text-base font-semibold">{content?.title}</h5>
        </div>
      ) : (
        ""
      )}
      <div
        className="flex cursor-pointer justify-end text-tertiary-6 underline"
        onClick={handleToggleAll}
      >
        {isExpandAll ? content.collapseAllButton : content.expandAllButton}
      </div>
      <Accordion
        key={content?.key}
        openIndices={controlledOpenIndices}
        headerClasses="border-none text-start"
        items={content?.items?.map((item, idx) => ({
          title: (
            <span
              className={clsx("text-start text-base font-semibold", classNames?.accordion?.title)}
            >
              {item?.title}
            </span>
          ),
          classNames: {
            container: clsx(`${idx === 0 && "border-none"} `, classNames?.accordion?.container),
          },
          content: (
            <ul className="">
              <PortableText value={item?.content} />
            </ul>
          ),
        }))}
        setIsExpandAll={setIsExpandAll}
      />
    </div>
  );
};

export default Faq;
